/** Parse plan flags for sidebar + page gates. is_free unlocks everything. */

const flagOn = (plan, key) => {
  if (!plan) return false;
  const v = plan[key];
  return v === 1 || v === "1" || v === true;
};

export function parseUserPlan(user) {
  if (!user) return null;
  try {
    return typeof user.plan === "string" ? JSON.parse(user.plan) : user.plan || null;
  } catch {
    return null;
  }
}

export function getPlanFeatures(user) {
  const free = Number(user?.is_free) === 1;
  if (free) {
    return {
      free: true,
      chatbot: true,
      bulk: true,
      schedule: true,
      api: true,
      webhook: true,
      multiInstance: true,
    };
  }
  const plan = parseUserPlan(user);
  return {
    free: false,
    chatbot: flagOn(plan, "allowchatbot"),
    bulk: flagOn(plan, "allowbulkmsg"),
    schedule: flagOn(plan, "allowschedulemsg"),
    api: flagOn(plan, "allowapi"),
    webhook: flagOn(plan, "allow_webhook"),
    multiInstance: flagOn(plan, "allow_multi_instance"),
  };
}
